import VueRouter from "vue-router";
import jQueryPlugins from "@/plugins/jQueryPlugins";
import {BootstrapVue, IconsPlugin} from 'bootstrap-vue';
import VeeValidationPlugin from "@/plugins/VeeValidationPlugin";
import globalComponent from "@/plugins/globalComponent";
import VueCookies from 'vue-cookies';
import axiosPlugin from "@/plugins/axiosPlugin";
import VueLoadingOverlayPlugin from "./vueLoadingOverlayPlugin";
import PNotifyPlugin from "@/plugins/PNotifyPlugin";

// Filters
import DateTimeFilters from "@/filters/DateTimeFilters";

// Directive
import HasPermission from "@/directives/HasPermission";

// Global Mixins
import httpMixins from "@/mixins/httpMixins";
import hasPermissionMixins from "@/mixins/hasPermissionMixins";

// TODO nghiên cứu chuyển sang dùng bootstrap-vue
import "bootstrap/dist/js/bootstrap.bundle.min"
import "@/assets/scss/cybertron.scss";

export default {
  install(Vue) {
    Vue.use(VueRouter);
    Vue.use(VueCookies);
    Vue.use(BootstrapVue);
    Vue.use(IconsPlugin);
    Vue.use(VeeValidationPlugin);
    Vue.use(globalComponent);
    Vue.use(VueLoadingOverlayPlugin);
    Vue.use(jQueryPlugins);
    Vue.use(PNotifyPlugin);
    Vue.use(axiosPlugin);

    // Filters
    Vue.use(DateTimeFilters);

    // Directive
    Vue.use(HasPermission);

    // Global Mixins
    Vue.mixin(httpMixins);
    Vue.mixin(hasPermissionMixins);
  }
}